import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function startResearch(pageId, seedKeyword) {
  return axios.post(`/ajax/website_pages/${pageId}/research_keywords`, { seed_keyword: seedKeyword })
}

export function getResearch(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/keyword_research`)
}

export function selectKeyword(pageId, candidateOrPayload) {
  let payload = candidateOrPayload
  if (typeof candidateOrPayload !== 'object') {
    payload = { candidate_id: candidateOrPayload }
  }

  return axios.post(`/ajax/website_pages/${pageId}/select_keyword`, payload)
}
